<template>
	<div class="hud">
		<div class="nav -top">
			<router-link to="/">
				<img class="logo" src="/static/commons/logo.svg" alt="">
			</router-link>
			<router-link to="/list">
				<div class="burger" :class="{'-close': isViewer}">
					<span class="line"></span>
					<span class="line -short"></span>
				</div>
			</router-link>
		</div>
		<div class="nav -bottom">
			<a href="https://instagram.com/haere.pictures/" target="_blank" rel="noopener" class="link">
				<i class="icon icon-instagram"></i>
			</a>
			<a href="https://www.facebook.com/haere.pics" target="_blank" rel="noopener" class="link">
				<i class="icon icon-facebook"></i>
			</a>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import LoaderMixin from '@/mixins/LoaderMixin'

export default {
	name: 'hud',
	mixins: [LoaderMixin],
	methods: {
		onLoadComplete () {
			this.loaded = true
		}
	},
	computed: {
		...mapGetters({
			data: 'data'
		}),
		isViewer (oldValue, newValue) {
			return (this.$route.name === 'viewer')
		}
	},
	data () {
		return {
			loaded: false
		}
	},
	created () {
		// get an array of unique categories name
		// e.g: ['australia', 'new-zealand']
		this.manifest = [
			...new Set(this.data.map(
				i => i.data.category.slug
			))
		].map(i => { // format that array into a manifest object
			return {
				url: `/static/categories/${i}.svg`,
				type: 'text'
			}
		})
		// start loading the manifest
		this.load(this.manifest)
	}
}
</script>

<style lang="stylus">
.hud {
}
.hud .nav{
	position: fixed;
	display: flex;
	justify-content: space-between;
	z-index: 4;
	width: 100%;
	padding: 0 var(--padding);
	transition: all 0.5s;

	&.-bottom{
		justify-content: start;
	}
}
.hud .link{
	margin-right: 0.5rem;
	transition: transform 0.2s ease;

	&:hover{
		transform: scale(1.1);
	}
}
.hud .logo{
	height: 1.5rem;
}
.burger{
	display: flex;
	width: 1.5rem;
	height: 1.5rem;
	align-items: center;
	justify-content: center;
	flex-direction: column;

	&:hover{
		.line:after{
			transform: scaleX(1);
			opacity: 1;
		}
	}

	&.-close{
		.line:nth-child(1){
			transform: translateY(0.1rem) rotate(-45deg);
			transform-origin: center center;
		}
		.line:nth-child(2){
			margin-top: 0;
			transform: scaleX(1) rotate(45deg);
			transform-origin: center center;
		}
	}
}
.line{
	width: 2rem;
	height: 0.1rem;
	position: relative;
	display: block;
	background: #434243;
	overflow: hidden;
	transition: all 0.2s;

	&:nth-child(2):after { transition-delay: 0.1s; }
}
.line.-short{
	margin-top: 0.3rem;
	transform: scaleX(0.6);
	transform-origin: left;
}
.line:after{
	content: '';
	position: absolute;
	height: 100%;
	width: 100%;
	transform: scaleX(0);
	background: #A5A5A5;
	transition: all 0.2s;
	transform-origin: left;
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Hud.vue